// eslint-disable-next-line no-unused-vars
import webpackEntry from 'webpack-entry';

import { PluginManifest, PluginStore } from 'graylog-web-plugin/plugin';
import packageJson from '../../package.json';
import LicensesPage from './LicensesPage';
import LicenseNotificationContainer from './notifications/LicenseNotificationContainer';

PluginStore.register(new PluginManifest(packageJson, {
  routes: [
    { path: '/system/licenses', component: LicensesPage },
  ],
  systemnavigation: [
    { path: '/system/licenses', description: 'Licenses', permissions: 'inputs:create' },
  ],
  globalNotifications: [
    {
      key: 'org.graylog.plugins.license.LicenseNotificationContainer',
      component: LicenseNotificationContainer,
    },
  ],

}));



// WEBPACK FOOTER //
// ./src/web/index.jsx